import {renderLogoTextSize} from "../../controllers/SystemUmmiaLogoTextController";
import {isNullOrUndefined} from "../../services/Validator";
import {kSystemImages} from "../../constants/images";

export default function SystemNeoUmmiaLogoTextImage({logoTextSize, onLogoPressed, extraClass}) {
    // Used through different header components to show app
    // logo text with a given size

    // BUILD
    return(
        <div className={`${extraClass} + " " + ${renderLogoTextSize(logoTextSize)} + ${isNullOrUndefined(onLogoPressed) ? "" : " cursor-pointer"}`}
             onClick={onLogoPressed}>
            <img className={"h-full object-contain"}
                 src={kSystemImages.neoUmmiaLogoText}
                 alt="Logo" />
        </div>
    );
}